import { AxisType, TypeSize } from '@entities/Filter';
import { Part, PartProduct, SeasonEnum, TornEnum } from '@entities/Product';

// FSD : `ошибка fsd`
import { RowAvailabilityTypeProps } from '@features/productAvailabilityInTheStores/ui/RowAvailability/TypeProps';

export interface Labels {
  isNew: boolean;
  isFreeStorage: boolean;
  isBshm: boolean;
  isDiscount: boolean;
}

export enum TypeAction {
  GiftWithPurchase = 1,
  DiscountSale,
  Cashback,
  CreditInstallmentPlan,
  FreeTireService,
  Storage,
  Sale,
}

export enum TypeCard {
  Sparky = 'sparky',
  ModelProduct = 'model-product',
  ArchivedModels = 'archived-models-product',
}

export interface ActionType {
  name: string;
  shortName: string;
  announce: string;
  href: string;
  type?: TypeAction[];
}

export interface BaseProductSchema {
  mainTitle: string;
  url: string;
  images: string[];
  price: number;
  part: PartProduct | Part;
  season?: SeasonEnum;
  spikes?: TornEnum;
  isNew?: boolean;
  stickers: {
    actions: ActionType[];
    warranties: ActionType[];
  };
}

export interface ProductType extends BaseProductSchema {
  rn: number;
  title: string;
  subTitle: string;
  carBrand: string;
  originalPrice: number;
  id: number;
  availability?: RowAvailabilityTypeProps;
  allQuantity: number;
  width: number;
  profile: number;
  diameter: number;
}

export interface SizeModels extends Omit<ProductType, 'width' | 'profile' | 'diameter' | 'season' | 'spikes' | 'stickers' | 'images'> {
  type: TypeSize;
  axis: AxisType;
}

export interface ModalProductType extends BaseProductSchema {
  firstRn: number;
  itemsProduct?: SizeModels[];
  className?: string;
  type?: TypeCard;
}

export interface PaginationType {
  currentPage: number;
  totalItems: number;
  totalPages: number;
}

export interface SizesType {
  title: string;
  href: string;
  links: Array<Record<'title' | 'href', string>>;
}

export interface CatalogSchema {
  pagination: PaginationType;
  isFetching: boolean;
  isInitial: boolean;
  initProductList: ProductType[];
  initModelList: ModalProductType[];
  initSparkyList: ModalProductType[];
  initArchivedModels: ModalProductType[];
  allSizes: SizesType[];
}

export enum PageType {
  Product,
  Brand,
}
